module.exports = __webpack_public_path__ + "static/media/31.4f95250b.jpg";